(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-hero-media')) {
    class CampaignHeroMedia extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        const video = this.video;
        // iOS and Android only autoplay when muted + inline is set as properties, not just attributes.
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('webkit-playsinline', '');

        this.desktopQuery = window.matchMedia('(min-width: 750px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        video.addEventListener('playing', () => this.setAttribute('data-playing', ''));
        video.addEventListener('pause', () => {
          if (!video.ended) this.removeAttribute('data-playing');
        });

        this.update = () => this.load();
        this.desktopQuery.addEventListener('change', this.update);
        this.motionQuery.addEventListener('change', this.update);

        // Low Power Mode / data saver refuse autoplay; the first touch or scroll counts as a gesture.
        this.retry = () => this.play();
        ['touchend', 'click', 'scroll'].forEach((type) =>
          window.addEventListener(type, this.retry, { once: true, passive: true })
        );

        // Only play while on screen: saves battery and data on phones.
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          if (this.inView) this.play();
          else video.pause();
        });
        this.observer.observe(this);

        this.load();
      }

      disconnectedCallback() {
        if (!this.video) return;
        this.desktopQuery.removeEventListener('change', this.update);
        this.motionQuery.removeEventListener('change', this.update);
        ['touchend', 'click', 'scroll'].forEach((type) => window.removeEventListener(type, this.retry));
        this.observer.disconnect();
      }

      load() {
        const video = this.video;

        if (this.motionQuery.matches) {
          video.pause();
          this.removeAttribute('data-playing');
          return;
        }

        const src = this.desktopQuery.matches ? video.dataset.srcDesktop : video.dataset.srcMobile;
        if (src && video.dataset.currentSrc !== src) {
          video.dataset.currentSrc = src;
          this.removeAttribute('data-playing');
          video.src = src;
          video.load();
        }

        this.play();
      }

      play() {
        const video = this.video;
        if (!video || this.motionQuery.matches || this.inView === false) return;
        if (!video.paused && this.hasAttribute('data-playing')) return;

        const attempt = video.play();
        if (attempt) attempt.catch(() => {});
      }
    }

    customElements.define('campaign-hero-media', CampaignHeroMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-contact-status')) {
    class PsContactStatus extends HTMLElement {
      connectedCallback() {
        const status = this.querySelector('[data-status]');
        const text = this.querySelector('[data-status-text]');
        if (!status || !text) return;

        const parts = Object.fromEntries(
          new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/Bucharest',
            weekday: 'short',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23',
          })
            .formatToParts(new Date())
            .map((part) => [part.type, part.value])
        );
        const days = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
        const day = days[parts.weekday];
        const minutes = Number(parts.hour) * 60 + Number(parts.minute);
        const toMinutes = (value) => {
          const [hours, mins] = String(value || '').split(':').map(Number);
          return hours * 60 + (mins || 0);
        };
        const lastDay = this.dataset.days === 'mon_sat' ? 6 : 5;
        const open = day <= lastDay && minutes >= toMinutes(this.dataset.open) && minutes < toMinutes(this.dataset.close);

        status.dataset.open = String(open);
        text.textContent = open
          ? 'Suntem la telefon acum'
          : `Telefonul revine la ${this.dataset.open}. Pe WhatsApp îți răspundem și acum.`;
        status.hidden = false;
      }
    }

    customElements.define('ps-contact-status', PsContactStatus);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paul-whatsapp-guide"] && !Shopify.designMode) return;
  try {
    
  class PaulWhatsAppGuide extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.dismissButton = this.querySelector('[data-paul-dismiss]');
      this.button = this.querySelector('.ps-paul-guide__button');
      this.message = this.querySelector('[data-paul-message]');
      this.storageKey = this.dataset.storageKey;
      this.messageDuration = Number(this.dataset.messageDuration) || 9000;
      this.cartCount = Number(this.dataset.cartCount) || 0;
      this.designMode = this.dataset.designMode === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.dismissed = this.wasDismissed();
      this.primaryPromptShown = false;
      this.followupPromptShown = false;
      this.timers = {};

      this.whatsappLinks = this.querySelectorAll('[data-paul-whatsapp]');
      this.ctaLink = this.querySelector('[data-paul-cta-link]');
      this.ctaLabel = this.querySelector('[data-paul-cta]');
      this.bubbleAction = 'chat';
      this.waContext = this.dataset.waContext;
      this.bindBubble();
      this.bindScroll();
      this.bindStoreEvents();
      this.bindAttention();

      const reveal = () =>
        window.setTimeout(() => this.enter(), this.designMode ? 0 : Number(this.dataset.revealDelay) || 0);
      this.afterBuyBox(reveal);
    }

    // On a product page on mobile, the button waits until the shopper has scrolled past the buy button,
    // so it never covers the photo, price or sizes while they are choosing.
    afterBuyBox(callback) {
      const buyButtons = document.querySelector('.product-details .buy-buttons-block');
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (this.designMode || !buyButtons || !isMobile || !('IntersectionObserver' in window)) {
        callback();
        return;
      }

      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting || entry.boundingClientRect.top > 0) return;
        observer.disconnect();
        callback();
      });
      observer.observe(buyButtons);
      this.listenerOptions.signal.addEventListener('abort', () => observer.disconnect());
    }

    disconnectedCallback() {
      this.abort?.abort();
      Object.values(this.timers).forEach((timer) => window.clearTimeout(timer));
    }

    get listenerOptions() {
      this.abort ??= new AbortController();
      return { signal: this.abort.signal, passive: true };
    }

    later(name, callback, delay) {
      window.clearTimeout(this.timers[name]);
      this.timers[name] = window.setTimeout(callback, delay);
    }

    enter() {
      this.classList.add('is-visible');
      this.ping();
      this.later('enter', () => {
        if (this.dataset.showMessageImmediately === 'true' || this.designMode) {
          this.say('', { autoHide: !this.designMode });
        }
        this.resetIdleTimer();
      }, this.reducedMotion ? 0 : 600);
    }

    ping() {
      this.classList.remove('is-pinging');
      void this.offsetWidth;
      this.classList.add('is-pinging');
      this.later('ping', () => this.classList.remove('is-pinging'), 3400);
    }

    // Messages respect a dismissal unless they answer something the shopper just did.
    say(message = '', { autoHide = true, typing = true, force = false, retype = false, action } = {}) {
      if (this.dismissed && !force) return;
      // Not on screen yet (e.g. waiting below the buy box): no card, it would be invisible but tappable.
      if (!this.classList.contains('is-visible')) return;
      if (message || action) this.setBubbleAction(action === 'size' && this.sizeChartTrigger ? 'size' : 'chat');

      const wasVisible = this.classList.contains('is-bubble-visible');
      const changed = message && this.message && this.message.textContent !== message;
      if (changed) this.message.textContent = message;
      this.classList.add('is-bubble-visible');
      // A new message (not a hover preview) lights the badge until WhatsApp is opened or the card closed.
      if (!wasVisible && typing) {
        this.classList.add('has-unread');
        this.ping();
      }

      if (typing && !this.reducedMotion && (changed || retype || !wasVisible)) {
        this.classList.add('is-typing');
        this.later('typing', () => this.classList.remove('is-typing'), 650);
      }

      if (autoHide) this.scheduleHide(this.messageDuration);
      else this.cancelHide();
    }

    // The card either opens WhatsApp or, after a size pick, the product's size chart.
    get sizeChartTrigger() {
      return document.querySelector('[class^="ai-size-guide-trigger-"]');
    }

    setBubbleAction(action) {
      this.bubbleAction = action;
      this.dataset.bubbleAction = action;
      if (this.ctaLabel) this.ctaLabel.textContent = action === 'size' ? this.dataset.sizeCtaLabel : this.dataset.ctaLabel;
      this.ctaLink?.setAttribute('aria-label', action === 'size' ? this.dataset.sizeCtaLabel : this.dataset.linkLabel);
    }

    scheduleHide(delay) {
      if (this.designMode) return;
      this.later('hide', () => this.classList.remove('is-bubble-visible'), delay);
    }

    cancelHide() {
      window.clearTimeout(this.timers.hide);
    }

    wasDismissed() {
      try {
        return window.sessionStorage.getItem(this.storageKey) === 'true';
      } catch (_error) {
        return false;
      }
    }

    dismissMessage() {
      this.dismissed = true;
      this.cancelHide();
      this.classList.remove('is-bubble-visible', 'is-typing', 'has-unread');
      try {
        window.sessionStorage.setItem(this.storageKey, 'true');
      } catch (_error) {
        // Storage unavailable; the dismissal lasts for this page only.
      }
      this.button?.focus();
    }

    bindBubble() {
      const options = this.listenerOptions;
      this.dismissButton?.addEventListener('click', () => this.dismissMessage(), { signal: options.signal });

      // Desktop: hovering the button previews the current message.
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.cancelHide();
        if (!this.classList.contains('is-bubble-visible')) this.say('', { autoHide: false, typing: false });
      }, options);
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.scheduleHide(1400);
      }, options);
      this.addEventListener('focusin', () => {
        this.cancelHide();
      }, options);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.scheduleHide(1400);
      }, options);

      // Opening WhatsApp from the button or the card clears the badge and closes the card.
      this.whatsappLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          this.classList.remove('has-unread');
          if (link === this.ctaLink && this.bubbleAction === 'size') {
            const trigger = this.sizeChartTrigger;
            if (!trigger) return;
            event.preventDefault();
            this.cancelHide();
            this.classList.remove('is-bubble-visible');
            trigger.click();
            return;
          }
          this.later('closeAfterOpen', () => this.classList.remove('is-bubble-visible'), 300);
        }, { signal: options.signal });
      });
    }

    // WhatsApp: the chat opens with a message written in the shopper's voice, with what they were looking at.
    updateWhatsApp(context = this.waContext) {
      this.waContext = context;
      const templates = {
        product: this.dataset.waProductTemplate,
        sold_out: this.dataset.waSoldOutTemplate,
        cart: this.dataset.waCartTemplate,
        added: this.dataset.waAddedTemplate,
      };
      const template = context === 'cart' && !this.dataset.waCart ? this.dataset.waDefaultTemplate : templates[context];
      if (!template || !this.whatsappLinks.length) return;

      const size = this.dataset.waSize ? `, mărimea ${this.dataset.waSize}` : '';
      let text = template
        .replaceAll('[product]', this.dataset.waProduct)
        .replaceAll('[size]', size)
        .replaceAll('[cart]', this.dataset.waCart);
      if (this.dataset.waUrl) text += `\n${this.dataset.waUrl}`;
      const href = `${this.dataset.waBase}?text=${encodeURIComponent(text)}`;
      this.whatsappLinks.forEach((link) => (link.href = href));
    }

    rememberCart(cart) {
      if (!Array.isArray(cart?.items)) return;
      this.dataset.waCart = cart.items
        .map((item) => {
          const name = (item.product_title || item.title || '').replace(/,?\s*din piele natural[aă]\s*$/i, '').trim();
          const sizeOption = (item.options_with_values || []).find((option) => /rime|size|num/i.test(option.name));
          const sizeValue = sizeOption?.value || (item.variant_title !== 'Default Title' ? item.variant_title : '');
          const size = sizeValue ? ` (mărimea ${sizeValue})` : '';
          return `${name}${size}`;
        })
        .join('; ');
    }

    bindScroll() {
      window.addEventListener('scroll', () => {
        this.resetIdleTimer();

        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 0 || !this.classList.contains('is-visible')) return;
        const progress = (window.scrollY / scrollable) * 100;

        if (!this.primaryPromptShown && progress >= Number(this.dataset.scrollTrigger)) {
          this.primaryPromptShown = true;
          this.later('scrollPause', () => this.prompt('greeting', ''), 500);
        } else if (!this.followupPromptShown && progress >= 65) {
          this.followupPromptShown = true;
          this.later('scrollPause', () => this.prompt('followup', this.dataset.followupMessage), 500);
        }
      }, this.listenerOptions);
    }

    bindStoreEvents() {
      const options = this.listenerOptions;

      document.addEventListener('cart:update', (event) => {
        const data = event.detail?.data || {};
        const resource = event.detail?.resource;
        if (data.didError) {
          this.say(this.dataset.cartErrorMessage);
          return;
        }

        const count = Number.isFinite(resource?.item_count) ? resource.item_count : Number(data.itemCount);
        this.rememberCart(resource);
        if (this.waContext === 'cart') this.updateWhatsApp('cart');
        if (data.source === 'product-form-component') {
          this.updateWhatsApp(this.dataset.waContext === 'cart' ? 'cart' : 'added');
          if (Number.isFinite(count)) this.cartCount = count;
          return;
        }

        if (data.source === 'cart-items-component' && Number.isFinite(count)) {
          if (count < this.cartCount) this.say(this.dataset.removedMessage);
          this.cartCount = count;
        }
      }, options);

      document.addEventListener('cart:error', () => {
        this.say(this.dataset.cartErrorMessage);
      }, options);

      document.addEventListener('variant:update', (event) => {
        const variant = event.detail?.resource;
        if (!variant) return;
        const sizeIndex = this.dataset.waSizeIndex === '' ? NaN : Number(this.dataset.waSizeIndex);
        const size = (Array.isArray(variant.options) && variant.options[sizeIndex]) || variant.public_title || variant.title || '';
        this.dataset.waSize = size === 'Default Title' ? '' : size;
        this.updateWhatsApp(variant.available === false ? 'sold_out' : 'product');
        if (variant.available === false) {
          this.say(this.dataset.soldOutMessage, { force: true, retype: true });
        } else if (this.sizeChartTrigger && this.dataset.sizeMessage) {
          // Only remind about the size table when this product actually has one.
          this.say(this.dataset.sizeMessage, { force: true, retype: true, action: 'size' });
        }
      }, options);
    }

    bindAttention() {
      const options = this.listenerOptions;
      ['pointerdown', 'keydown', 'touchstart'].forEach((type) => {
        document.addEventListener(type, () => this.resetIdleTimer(), options);
      });

      // Desktop exit intent: the cursor leaves through the top of the window.
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        const readyAt = performance.now() + 8000;
        document.addEventListener('mouseout', (event) => {
          if (event.relatedTarget || event.clientY > 0 || performance.now() < readyAt) return;
          this.prompt('exit', this.dataset.exitMessage);
        }, options);
      }

      // Welcome back after switching tabs or apps for a while.
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.hiddenAt = performance.now();
        } else if (this.hiddenAt && performance.now() - this.hiddenAt > 15000) {
          this.later('welcome', () => this.prompt('welcome', this.dataset.welcomeBackMessage), 600);
        }
      }, options);
    }

    // Idle: after a quiet stretch, offer help once.
    resetIdleTimer() {
      const delay = Number(this.dataset.idleDelay);
      if (!delay || this.followupPromptShown || !this.classList.contains('is-visible')) return;
      this.later('idle', () => {
        if (this.followupPromptShown || document.hidden) return;
        this.followupPromptShown = true;
        this.prompt('followup', this.dataset.followupMessage);
      }, delay);
    }

    // Unprompted messages are rationed per visit: each kind once, one per page, a few minutes apart,
    // and never over an open card. Replies to what the shopper does (size, cart) are not limited.
    prompt(kind, message) {
      if (this.designMode || this.dismissed || this.promptedThisPage) return;
      if (this.classList.contains('is-bubble-visible')) return;

      const key = `${this.storageKey}-prompts`;
      let log = { count: 0, kinds: [], last: 0 };
      try {
        log = { ...log, ...JSON.parse(window.sessionStorage.getItem(key) || '{}') };
      } catch (_error) {
        // Storage unavailable; limits apply to this page only.
      }

      const max = Number(this.dataset.maxPrompts);
      if (log.count >= max || log.kinds.includes(kind)) return;
      if (log.last && Date.now() - log.last < 120000) return;

      this.promptedThisPage = true;
      log = { count: log.count + 1, kinds: [...log.kinds, kind], last: Date.now() };
      try {
        window.sessionStorage.setItem(key, JSON.stringify(log));
      } catch (_error) {
        // Storage unavailable; limits apply to this page only.
      }
      this.say(message);
    }
  }

  if (!customElements.get('paul-whatsapp-guide')) {
    customElements.define('paul-whatsapp-guide', PaulWhatsAppGuide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-shop"] && !Shopify.designMode) return;
  try {
    
  class ProductShopCard extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.#handleSizeChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#handleSizeChange);
    }

    /**
     * @param {Event} event
     */
    #handleSizeChange = (event) => {
      const target = event.target;

      if (!(target instanceof HTMLInputElement) || target.dataset.variantId == null) return;

      const variantInput = this.querySelector('input[name="id"]');
      const addButton = this.querySelector('[ref="addToCartButton"]');
      const priceCurrent = this.querySelector('[data-shop-price-current]');
      const priceCompare = this.querySelector('[data-shop-price-compare]');
      const badge = this.querySelector('[data-shop-badge]');
      const available = target.dataset.available === 'true';
      const percent = Number(target.dataset.percent || 0);

      if (variantInput instanceof HTMLInputElement) {
        variantInput.value = target.dataset.variantId;
        variantInput.disabled = !available;
      }

      if (addButton instanceof HTMLButtonElement) {
        addButton.disabled = !available;
      }

      if (priceCurrent) {
        priceCurrent.textContent = target.dataset.price || '';
      }

      if (priceCompare instanceof HTMLElement) {
        if (target.dataset.compare) {
          priceCompare.textContent = target.dataset.compare;
          priceCompare.hidden = false;
        } else {
          priceCompare.textContent = '';
          priceCompare.hidden = true;
        }
      }

      if (badge instanceof HTMLElement) {
        badge.hidden = percent <= 0;
      }
    };
  }

  if (!customElements.get('product-shop-card')) {
    customElements.define('product-shop-card', ProductShopCard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-band"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-quote-band')) {
    class PsQuoteBand extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.quote-band__slide'));
        if (this.slides.length < 2) return;

        this.index = 0;
        this.interval = Number(this.dataset.interval) || 6000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.querySelectorAll('[data-step]').forEach((button) => {
          button.addEventListener('click', () => {
            this.show(this.index + Number(button.dataset.step));
            this.restart();
          });
        });

        ['mouseenter', 'focusin'].forEach((type) => this.addEventListener(type, () => this.stop()));
        ['mouseleave', 'focusout'].forEach((type) => this.addEventListener(type, () => this.restart()));

        this.visibility = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.restart();
        });
        this.visibility.observe(this);
      }

      disconnectedCallback() {
        this.stop();
        if (this.visibility) this.visibility.disconnect();
      }

      show(nextIndex) {
        const count = this.slides.length;
        this.index = (nextIndex + count) % count;
        this.slides.forEach((slide, i) => {
          slide.hidden = i !== this.index;
        });
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        if (!this.inView || this.reducedMotion.matches || this.matches(':hover, :focus-within')) return;
        this.timer = setInterval(() => this.show(this.index + 1), this.interval);
      }
    }

    customElements.define('ps-quote-band', PsQuoteBand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-reviews-list')) {
    const TOPIC_KEYS = ['marime', 'schimb', 'retur', 'livrare'];
    const dateFormat = new Intl.DateTimeFormat('ro-RO', { day: 'numeric', month: 'long', year: 'numeric' });

    const element = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    };

    const resize = (url, width) =>
      /[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, `$1${width}`) : `${url}${url.includes('?') ? '&' : '?'}width=${width}`;

    class PsReviewsList extends HTMLElement {
      async connectedCallback() {
        this.items = this.querySelector('[data-items]');
        this.status = this.querySelector('[data-status]');
        this.moreButton = this.querySelector('[data-more]');
        this.chips = Array.from(this.querySelectorAll('[data-topic]'));
        this.pageSize = Number(this.dataset.pageSize) || 8;
        this.serverCount = this.items.children.length;
        this.excluded = (this.dataset.exclude || '').split(',').map((name) => name.trim()).filter(Boolean);
        this.topic = 'toate';
        this.starsSelect = this.querySelector('[data-stars]');
        this.stars = 0;

        this.chips.forEach((chip) => chip.addEventListener('click', () => this.select(chip.dataset.topic, true)));
        this.starsSelect.addEventListener('change', () => {
          this.stars = Number(this.starsSelect.value) || 0;
          this.select(this.topic, true);
        });

        /* Rating bars in the reviews header link here, e.g. ?stele=1#toate-recenziile. */
        this.onStarsLink = (event) => {
          const link = event.target.closest('[data-stars-link]');
          if (!link || !this.reviews) return;
          event.preventDefault();
          this.stars = Number(link.dataset.starsLink) || 0;
          this.select('toate', true);
          this.closest('section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
        document.addEventListener('click', this.onStarsLink);
        this.moreButton.addEventListener('click', () => this.render(this.shown + this.pageSize));

        try {
          const data = await fetch(this.dataset.src).then((response) => response.json());
          this.images = data.images || {};
          this.reviews = data.reviews.filter((review) => !this.isExcluded(review));
        } catch (error) {
          if (!this.serverCount) this.status.textContent = 'Recenziile nu au putut fi încărcate.';
          return;
        }

        const params = new URLSearchParams(window.location.search);
        const requested = params.get('topic');
        this.stars = Math.min(Math.max(Number(params.get('stele')) || 0, 0), 5);
        const topic = this.chips.some((chip) => chip.dataset.topic === requested) ? requested : 'toate';
        this.select(topic, false, topic === 'toate' && !this.stars ? Math.max(this.serverCount, this.pageSize) : this.pageSize);
        this.addLatest();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onStarsLink);
      }

      isExcluded(review) {
        const name = (review.n || '').toLowerCase();
        return this.excluded.some((excluded) => name.includes(excluded));
      }

      /* Newest reviews come live from Judge.me so they show before the data file is rebuilt. */
      async addLatest() {
        try {
          const { html } = await fetch(this.dataset.live).then((response) => response.json());
          const doc = new DOMParser().parseFromString(html || '', 'text/html');
          const known = new Set(this.reviews.map((review) => review.id));
          const fresh = [];

          doc.querySelectorAll('.jdgm-rev[data-review-id]').forEach((node) => {
            const id = node.dataset.reviewId;
            if (known.has(id)) return;
            const text = (selector) => node.querySelector(selector)?.textContent.trim() || '';
            const link = node.querySelector('.jdgm-rev__prod-link');
            const review = {
              id,
              r: Number(node.querySelector('[data-score]')?.dataset.score) || 0,
              v: node.dataset.verifiedBuyer === 'true',
              n: text('.jdgm-rev__author'),
              d: (node.querySelector('[data-content]')?.dataset.content || '').slice(0, 10),
              t: text('.jdgm-rev__title'),
              b: text('.jdgm-rev__body'),
              p: text('.jdgm-rev__prod-link') || text('.jdgm-rev__prod-title'),
              h: link ? (link.getAttribute('href') || '').split('/products/')[1] || '' : '',
              ph: Array.from(node.querySelectorAll('[data-mfp-src]')).map((photo) => photo.dataset.mfpSrc),
              rp: text('.jdgm-rev__reply-content'),
              tg: [],
            };
            if (review.ph.length) review.tg.push('poze');
            if (!this.isExcluded(review)) fresh.push(review);
          });

          if (!fresh.length) return;
          await Promise.all(
            [...new Set(fresh.map((review) => review.h).filter((handle) => handle && !this.images[handle]))].map((handle) =>
              fetch(`/products/${handle}.js`)
                .then((response) => (response.ok ? response.json() : null))
                .then((product) => {
                  if (product?.featured_image) this.images[handle] = resize(product.featured_image, 240);
                })
                .catch(() => {})
            )
          );
          this.reviews = [...fresh, ...this.reviews];
          this.select(this.topic, false, Math.max(this.shown, this.pageSize));
        } catch (error) {
          /* Live reviews are a bonus; the data file already covers the page. */
        }
      }

      select(topic, userAction, count = this.pageSize) {
        this.topic = topic;
        this.chips.forEach((chip) => {
          chip.setAttribute('aria-selected', String(chip.dataset.topic === topic));
          const count = this.filtered(chip.dataset.topic, this.stars).length;
          chip.querySelector('[data-count]').textContent = count;
          chip.hidden = chip.dataset.topic !== 'toate' && chip.dataset.topic !== topic && count === 0;
        });
        this.querySelectorAll('[data-answer]').forEach((answer) => {
          answer.hidden = answer.dataset.answer !== topic;
        });

        this.starsSelect.value = this.stars ? String(this.stars) : '';
        Array.from(this.starsSelect.options).forEach((option) => {
          const stars = Number(option.value);
          const label = stars ? `${stars} ${stars === 1 ? 'stea' : 'stele'}` : 'Toate notele';
          option.textContent = `${label} (${this.filtered(topic, stars).length})`;
        });

        if (userAction) {
          const url = new URL(window.location.href);
          if (topic === 'toate') url.searchParams.delete('topic');
          else url.searchParams.set('topic', topic);
          if (this.stars) url.searchParams.set('stele', this.stars);
          else url.searchParams.delete('stele');
          history.replaceState(null, '', url);
        }

        this.render(count);
      }

      filtered(topic, stars = 0) {
        if (!this.reviews) return [];
        const pool = stars ? this.reviews.filter((review) => review.r === stars) : this.reviews;
        if (topic === 'toate') return pool;
        const matches = pool.filter((review) => (review.tg || []).includes(topic));
        if (!TOPIC_KEYS.includes(topic)) return matches;
        return matches
          .map((review, index) => ({ review, index }))
          .sort((a, b) => (a.review.pr?.[topic] ?? 999) - (b.review.pr?.[topic] ?? 999) || a.index - b.index)
          .map(({ review }) => review);
      }

      render(count) {
        const list = this.filtered(this.topic, this.stars);
        this.shown = Math.min(count, list.length);
        this.items.replaceChildren(...list.slice(0, this.shown).map((review) => this.card(review)));
        this.status.textContent = list.length ? '' : 'Nu sunt recenzii pentru acest filtru.';
        this.moreButton.hidden = this.shown >= list.length;
      }

      card(review) {
        const item = element('li', 'reviews-list__item');
        const productImage = this.images[review.h] || this.images[review.ph_h];

        const figure = element('figure', 'reviews-list__figure');
        if (review.ph?.length || productImage) {
          const img = element('img');
          img.src = review.ph?.length ? resize(review.ph[0], 240) : productImage;
          img.alt = review.ph?.length ? `Fotografie de la ${review.n || 'client'}` : review.p || '';
          img.width = 240;
          img.height = 240;
          img.loading = 'lazy';
          img.decoding = 'async';
          figure.append(img);
          if (review.ph?.length) figure.append(element('figcaption', 'reviews-list__figure-tag', 'Foto client'));
        } else {
          figure.classList.add('reviews-list__figure--empty');
          figure.textContent = 'PS';
          figure.setAttribute('aria-hidden', 'true');
        }

        const content = element('div', 'reviews-list__content');
        const top = element('div', 'reviews-list__top');
        const stars = element('span', 'ps-stars');
        stars.style.setProperty('--ps-stars-fill', `${review.r * 20}%`);
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', `${review.r} din 5 stele`);
        top.append(stars);
        if (review.d) {
          const date = new Date(`${review.d}T12:00:00`);
          if (!Number.isNaN(date.getTime())) top.append(element('time', 'reviews-list__date', dateFormat.format(date)));
        }
        content.append(top);

        if (review.t && review.t !== review.b && !review.b.startsWith(review.t)) {
          content.append(element('h3', 'reviews-list__title', review.t));
        }

        if (review.b) {
          const body = element('p', 'reviews-list__body', review.b);
          content.append(body);
          if (review.b.length > 260) {
            body.classList.add('reviews-list__body--clamp');
            const toggle = element('button', 'reviews-list__toggle', 'Citește tot');
            toggle.type = 'button';
            toggle.setAttribute('aria-expanded', 'false');
            toggle.addEventListener('click', () => {
              const open = body.classList.toggle('reviews-list__body--clamp') === false;
              toggle.textContent = open ? 'Mai puțin' : 'Citește tot';
              toggle.setAttribute('aria-expanded', String(open));
            });
            content.append(toggle);
          }
        }

        if (review.ph?.length > 1) {
          const photos = element('div', 'reviews-list__photos');
          review.ph.slice(1, 5).forEach((url) => {
            const link = element('a');
            link.href = url;
            link.target = '_blank';
            link.rel = 'noopener';
            const img = element('img');
            img.src = resize(url, 160);
            img.alt = 'Altă fotografie de la client';
            img.loading = 'lazy';
            link.append(img);
            photos.append(link);
          });
          content.append(photos);
        }

        const meta = element('div', 'reviews-list__meta');
        meta.append(element('span', 'reviews-list__name', review.n && review.n !== 'Anonim' ? review.n : 'Client PaulStyle'));
        if (review.v) {
          const verified = element('span', 'reviews-list__verified');
          verified.innerHTML =
            '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.5 6.5 11.5 12.5 4.5" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
          verified.append('Cumpărător verificat');
          meta.append(verified);
        }
        content.append(meta);

        if (review.p) {
          if (review.h) {
            const link = element('a', 'reviews-list__product', review.p);
            link.href = `/products/${review.h}`;
            content.append(link);
          } else {
            content.append(element('span', 'reviews-list__product', review.p));
          }
        }

        if (review.rp) {
          const reply = element('p', 'reviews-list__reply');
          reply.append(element('strong', '', 'Răspuns PaulStyle'), review.rp);
          content.append(reply);
        }

        item.append(figure, content);
        return item;
      }
    }

    customElements.define('ps-reviews-list', PsReviewsList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-review-rail')) {
    class PsReviewRail extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.reviews-showcase__rail');
        this.arrows = this.querySelector('.reviews-showcase__arrows');
        this.buttons = Array.from(this.querySelectorAll('[data-step]'));
        if (!this.rail) return;

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const card = this.rail.firstElementChild;
            const step = card ? card.getBoundingClientRect().width + 16 : this.rail.clientWidth;
            this.rail.scrollBy({ left: step * Number(button.dataset.step), behavior: 'smooth' });
          });
        });

        this.update = this.update.bind(this);
        this.rail.addEventListener('scroll', this.update, { passive: true });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.rail);
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      update() {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        if (this.arrows) this.arrows.hidden = max <= 2;
        if (this.buttons.length === 2) {
          this.buttons[0].disabled = this.rail.scrollLeft <= 2;
          this.buttons[1].disabled = this.rail.scrollLeft >= max - 2;
        }
      }
    }

    customElements.define('ps-review-rail', PsReviewRail);
  }

  } catch(e) { console.error(e); }
})();
})();
